import axios from 'axios'

// 根据环境选择API地址
const baseURL = process.env.NODE_ENV === 'production' 
  ? 'https://admin.xixijizhang.cn/api'  // 使用同域名，通过反向代理
  : 'http://47.96.13.116:3005/api'     // 开发环境用HTTP

// 创建axios实例
const api = axios.create({
  baseURL,
  timeout: 10000
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 添加认证头
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('API请求失败:', error)
    
    // 处理认证错误
    if (error.response && error.response.status === 401) {
      // 清除本地存储的token
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user_info')
      
      // 跳转到登录页
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    
    return Promise.reject(error)
  }
)

// 聚合链接API
export const aggregatorApi = {
  // 获取所有聚合链接
  getList() {
    return api.get('/aggregator')
  },
  
  // 获取单个聚合链接详情
  getDetail(id) {
    return api.get(`/aggregator/${id}`)
  },
  
  // 创建聚合链接
  create(data) {
    return api.post('/aggregator', data)
  },
  
  // 更新聚合链接
  update(id, data) {
    return api.put(`/aggregator/${id}`, data)
  },
  
  // 删除聚合链接
  delete(id) {
    return api.delete(`/aggregator/${id}`)
  }
}

// DeepLink API
export const deeplinkApi = {
  // 获取指定聚合链接的所有DeepLink
  getList(aggregatorId) {
    return api.get(`/deeplink/aggregator/${aggregatorId}`)
  },
  
  // 创建DeepLink
  create(data) {
    return api.post('/deeplink', data)
  },
  
  // 更新DeepLink
  update(id, data) {
    return api.put(`/deeplink/${id}`, data)
  },
  
  // 删除DeepLink
  delete(id) {
    return api.delete(`/deeplink/${id}`)
  },
  
  // 重置DeepLink点击次数
  reset(id) {
    return api.post(`/deeplink/${id}/reset`)
  },
  
  // 获取DeepLink统计
  getStats(id, params = {}) {
    return api.get(`/deeplink/${id}/stats`, { params })
  }
}

// 跳转统计API
export const redirectApi = {
  // 获取跳转统计
  getStats(aggregatorId, params = {}) {
    return api.get(`/r/${aggregatorId}/stats`, { params })
  }
}

// 认证API
export const authApi = {
  // 用户登录
  login(username, password) {
    return api.post('/auth/login', { username, password })
  },
  
  // 获取当前用户信息
  getCurrentUser() {
    return api.get('/auth/me')
  },
  
  // 验证令牌
  verifyToken() {
    return api.post('/auth/verify')
  },
  
  // 用户登出
  logout() {
    return api.post('/auth/logout')
  },
  
  // 获取所有用户列表
  getUsers() {
    return api.get('/auth/users')
  },
  
  // 创建新用户
  createUser(userData) {
    return api.post('/auth/users', userData)
  },
  
  // 更新用户信息
  updateUser(id, userData) {
    return api.put(`/auth/users/${id}`, userData)
  },
  
  // 删除用户
  deleteUser(id) {
    return api.delete(`/auth/users/${id}`)
  }
}

export default api
